/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgNodeTree = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M11 5.07A7.005 7.005 0 0 0 5.07 11H3v2h2.07A7.004 7.004 0 0 0 11 18.93V21h2v-2.07A7.004 7.004 0 0 0 18.93 13H21v-2h-2.07A7.004 7.004 0 0 0 13 5.07V3h-2v2.07zM12 7a5 5 0 1 1 0 10 5 5 0 0 1 0-10z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgNodeTree as NodeTree };
